import Card from "react-bootstrap/Card";
import styles from "./CustomCard.module.scss";

interface CustomCardType {
  img: string;
  title: string;
  subTitle?: string;
  content?: string; 
  position?: string;
}

export default function CustomCard({ img, title, subTitle, content, position }: CustomCardType) {
  return (
    <Card className="bg-dark text-white h-100">
      <Card.Img className="h-100" src={img} alt="Card image" />
      <Card.ImgOverlay className={`d-flex flex-column justify-content-${position}`}>
        <h5>
         {subTitle}
        </h5>
        <div className={styles.title}>{title}</div>
        <div className="fw-300 text-gray-400 text-7s">
         {content}
        </div>
      </Card.ImgOverlay>
    </Card>
  );
}
